import React, { Component } from 'react';
import './Recuperapass.css';
import clos from '../../images/public/registeration/clos.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import { userFetch, userLoginFetch, modifyEmail } from '../../libs/fetch';
import { userFetch, userLoginFetch } from '../../libs/fetch';
import HideBtn from "../../assets/components/button/HideBtn";
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import ovaz from '../../images/public/registeration/greenTick.png';
import { recoverPassword, checkCodeValidity, changeUserPasswordFetch } from '../../libs/fetch';
import { Config } from '../../Config';
import Cookies from 'universal-cookie';
import logo from '../../images/public/login/logo.png';
import trueImg from '../../images/public/registeration/true.png';

const cookies = new Cookies();
class Recuperapass extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			code: '',
			password: '',
			password1: '',
			changeScreenNum: 1,
			passFlagrp: true,
			onLoad: true,
			isSetPass: window.location.href.search('set_pass') !==-1,
		};

		this.forward0 = this.forward0.bind(this);
		this.forward1 = this.forward1.bind(this);
		this.forward2 = this.forward2.bind(this);
		this.forward3 = this.forward3.bind(this);
		this.handleEmail = this.handleEmail.bind(this);
		this.handleCode = this.handleCode.bind(this);
		this.handleChangePassword = this.handleChangePassword.bind(this);
		this.handleChangePassword1 = this.handleChangePassword1.bind(this);
	}

	handleEmail = (e) => {
		e.preventDefault();
		this.setState({ email: e.target.value });
		return
	}

	handleCode = (e) => {
		e.preventDefault();
		this.setState({ code: e.target.value });
		return
	}

	handleChangePassword = (e) => {
		e.preventDefault();
		this.setState({ password: e.target.value, errPass: false });
		return
	}

	handleChangePassword1 = (e) => {
		e.preventDefault();
		this.setState({ password1: e.target.value, errPass: false });
		return
	}

	forward0 = (e) => {
		e.preventDefault();
		// this.setState({ changeScreenNum: 1 });
		this.setState({ onLoad: false }, () => { this.resendCode() });
	}

	forward1 = (e) => {
		e.preventDefault();
		if (this.validateEmail()) {
				this.resendCode()
		}
	}

	forward2 = (e) => {
		e.preventDefault();
		//console.log('email rest here');
		if (this.validateCode()) {
			this.confirmCode();
		}
	}

	forward3 = (e) => {
		e.preventDefault();
		//console.log("resetting the password: ", this.validatePassword());

		if (this.validatePassword()) {
				this.changePassword();
		} else {
				this.setState({ errPass: true });
		}
	}

	isPasswordTheSame = () => {
		return this.state.password === this.state.password1
	}

	validatePassword = () => {
		return (
			this.state.password === this.state.password1
		)
	}

	validateEmail = () => {
		var mail = this.state.email;
		var regexp = new RegExp(/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		var validEmail = regexp.test(mail);
		this.setState({ emailErr: !validEmail });
		return validEmail;
	}

	validateCode = (e) => {
		var validCode = (this.state.code !== '');
		//console.log('validCode0',this.state.code,'validCode1', validCode);
		
		return validCode;
	}

	confirmCode = () => {
		checkCodeValidity(this, {
			email: this.state.email,
			code: this.state.code,
			language: tr.userlng().toLowerCase()
		}).then((response) => {
		if (response === null) return;
		if (response.status === "fail") this.handleAlert(response.message);
		if (response.status === "success") this.setState({ changeScreenNum: 3 });
		});
	}

    // resendCode = () => {
    //     sendCodeByEmail(this, { email: this.state.email, language: tr.userlng() })
    //         .then((response) => {

    //             // null
    //             if (response == null) {
    //                 return;
    //             }

    //             // fail
    //             if (response.status == "fail") {
    //                 console.log("sendCodeByEmail: !!FAIL!!: ", response.message)
    //                 this.setState({ redirect: false, redirectprev: true });
    //                 // alert(response.message)
    //                 this.handleAlert(response.message);
    //             }

    //             // success
    //             if (response.status == "success") {
    //                 this.setState({ changeScreenNum: 2 });
    //             }
    //         });
    // }

    resendCode = () => {
			recoverPassword(this, { email: this.state.email, language: tr.userlng() })
				.then((response) => {
					//console.log("recoverPassword: ", response)

					// null
					if (response === null) {
						return;
					}

					// fail
					if (response.status === "fail") {
						//console.log("recoverPassword: !!FAIL!!: ", response.message)
						this.setState({ redirect: false, redirectprev: true });
						// alert(response.message)
						this.handleAlert(response.message);
					}

					// success
					if (response.status === "success") {
						this.setState({ changeScreenNum: 2 });
						if (!this.state.onLoad) this.handleAlert(response.message);
					}
				});
    }

    changePassword = () => {

			let params = {
				email: this.state.email,
				oldPassword: this.state.code,
				newPassword: this.state.password
			}


			changeUserPasswordFetch(this, params).then((response) => {
				// null
				if (response === null) {
					return;
				}

				// fail
				if (response.status === "fail") {
					this.setState({ redirect: false, redirectprev: true });
					// alert(response.message)
					this.handleAlert(response.message);
				}

				// success
				if (response.status === "success") {
					this.setState({ changeScreenNum: 4 });
				}
			}).catch((error) => {

			});
    }

    alertResponse(info) {
			switch (info.type) {
				case "closeButton":
					this.setState({ inScreenPopupShow: false })
					break;
				case "actionButton":
					if (info.option1 === "attention")
						this.setState({ inScreenPopupShow: false })
					break;
				default:
					break;
			}
    }

    // Default browser alert function replacement
    handleAlert = (incomingMsg) => {
			//console.log("Incoming message:", incomingMsg);
			this.setState({
					inScreenPopupShow: true,
					inScreenPopupMsg: incomingMsg,
			})
    }

  // user login action
  // @params : username (mail) and password
  // @return : login object   
  onSuccess=(e)=> {
    e.preventDefault();
    try {

      // login
      userLoginFetch(this,
        {
          email: this.state.email,
          password: this.state.password,
          app: "web",
          platform: Config.platform,
          version: Config.version
        }
      )
        .then((response) => {
          //console.log("userLoginFetch: response: ", response)

          // null
          if (response === null) {
            return;
          }

          // fail
          if (response.status === "fail") {

            console.warn("userLoginFetch: !!FAIL!!: ", response.message)

          }
          else {

            cookies.set("access_token", response.access_token);

            //console.log("userLoginFetch: !!Success!!: ", response);

            try {
              // fill storage w/ user data.
              //console.log("userLoginFetch: !!Success!!:response.access_token  ", response.access_token);
              userFetch(this, { access_token: response.access_token }
              ).then((response) => {
               	//console.log("userLoginFetch: !!Success!!:", response);
                if (!response) {
                  localStorage.clear();
                  cookies.remove('access_token');
                  return this.setState({
                    warning: true,
                    warningMessage: "Errore di sistema!"
                  })
                }
                localStorage.setItem('user', JSON.stringify(response));
                return this.props.history.push('/');
              });
            } catch (e) {
              //console.log(e);
            }
          }
        });
    }
    catch (e) {
      //console.log(e);
    }
  }

    render() {
			return (
				<Router>
					<div>
						<div>
							<BrowserView>
							{
								this.state.changeScreenNum === 1 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => {return this.props.history.push('/')}}>
																		<img src={ clos } alt=""/>
																	</a>
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-12">
																<h3>{ this.state.isSetPass?tr.t("setPassword"):tr.t("Passrecovery") }</h3>
																<p>{ this.state.isSetPass?tr.t("setPassText"):tr.t("Resetpass") }</p>
																<input className="sn_input" spellCheck={false} type="email" name="mail" placeholder="user@mail.com" onChange={this.handleEmail} value={this.state.email} maxLength="50" />
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
																<button disabled={!isEmailValid(this.state.email)} className="sn_btn" onClick={this.forward1}>{tr.t("Continue")}</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							{
								this.state.changeScreenNum === 2 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => {return this.props.history.push('/')}}>
																		<img src={ clos } alt=""/>
																	</a>
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-12">
																<h3>{ this.state.isSetPass?tr.t("setPassword"):tr.t("Passrecovery") }</h3>
																<p>{ tr.t("Insertcode") }</p>
																<input type="tel" name="code" placeholder="12345" className="sn_input mb-3" value={this.state.code} onChange={this.handleCode} maxLength="5" />
																<h6 className="text-center cursor-poiner sn_underline" onClick={this.forward0}>{tr.t("Sendagain")}</h6>
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
																<button className="sn_btn" onClick={this.forward2}>{tr.t("Continue")}</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							{
								this.state.changeScreenNum === 3 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => {return this.props.history.push('/')}}>
																		<img src={ clos } alt="" />
																	</a>
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-12">
																<h3>{ this.state.isSetPass?tr.t("setPassword"):tr.t("Passrecovery") }</h3>
																<p>{ tr.t("Enternp") }</p>
																<input className="sn_input" style={{ borderBottomColor: this.state.errPass ? 'red' : '' }} spellCheck={false} type={(this.state.passFlagrp) ? "password" : "text"} name="newpass" placeholder={tr.t("Password")} maxLength="50" minLength="8" onChange={this.handleChangePassword} />
																<span>
																	<HideBtn registerationView={true} changei={(i) => { console.log("i", i); this.setState({ passFlagrp: i }) }} />
																</span>
																<input className="sn_input mt-3 mb-2" style={{ borderBottomColor: this.state.errPass ? 'red' : '' }} spellCheck={false} type={(this.state.passFlagrp) ? "password" : "text"} name="newpassconfirm" placeholder={tr.t("Confirmpass")} maxLength="50" minLength="8" onChange={this.handleChangePassword1} />
																<p>{ tr.t("Passleast") }</p>
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
															<button disabled={this.state.password.length < 8 || this.state.password !== this.state.password1} className="sn_btn" onClick={this.forward3}>{tr.t("Continue")}</button>  
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							{
								this.state.changeScreenNum === 4 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-12 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row mb-4 text-center">
															<div className="col-12">
																<div className="sn_bought__container__image mb-5 mx-auto">
																	<img src={ trueImg } alt=""/>
																</div>
																<h3 className="text-center">{ tr.t("Passchanged") }</h3>
																<p classsName="text-center">{ tr.t("Changeinfo") }</p>
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
																<button onClick={(e) => { this.onSuccess(e) }} className="sn_btn">{tr.t("Continue")}</button>
                      				</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							</BrowserView>
							<MobileView>
							{
								this.state.changeScreenNum === 1 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => {return this.props.history.push('/')}}>
																		<img src={ clos } alt=""/>
																	</a>
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-12">
																<h3>{ this.state.isSetPass?tr.t("setPassword"):tr.t("Passrecovery") }</h3>
																<p>{ this.state.isSetPass?tr.t("setPassText"):tr.t("Resetpass") }</p>
																<input className="sn_input" spellCheck={false} type="email" name="mail" placeholder="user@mail.com" onChange={this.handleEmail} value={this.state.email} maxLength="50" />
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
																<button disabled={!isEmailValid(this.state.email)} className="sn_btn" onClick={this.forward1}>{tr.t("Continue")}</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							{
								this.state.changeScreenNum === 2 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => {return this.props.history.push('/')}}>
																		<img src={ clos } alt=""/>
																	</a>
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-12">
																<h3>{ this.state.isSetPass?tr.t("setPassword"):tr.t("Passrecovery") }</h3>
																<p>{ tr.t("Insertcode") }</p>
																<input type="tel" name="code" placeholder="12345" className="sn_input mb-3" value={this.state.code} onChange={this.handleCode} maxLength="5" />
																<h6 className="text-center cursor-poiner sn_underline" onClick={this.forward0}>{tr.t("Sendagain")}</h6>
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
																<button className="sn_btn" onClick={this.forward2}>{tr.t("Continue")}</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							{
								this.state.changeScreenNum === 3 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => {return this.props.history.push('/')}}>
																		<img src={ clos } alt=""/>
																	</a>
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-12">
																<h3>{ this.state.isSetPass?tr.t("setPassword"):tr.t("Passrecovery") }</h3>
																<p>{ tr.t("Enternp") }</p>
																<input className="sn_input" style={{ borderBottomColor: this.state.errPass ? 'red' : '' }} spellCheck={false} type={(this.state.passFlagrp) ? "password" : "text"} name="newpass" placeholder={tr.t("Password")} maxLength="50" minLength="8" onChange={this.handleChangePassword} />
																<span>
																	<HideBtn registerationView={true} changei={(i) => { console.log("i", i); this.setState({ passFlagrp: i }) }} />
																</span>
																<input className="sn_input mt-3 mb-2" style={{ borderBottomColor: this.state.errPass ? 'red' : '' }} spellCheck={false} type={(this.state.passFlagrp) ? "password" : "text"} name="newpassconfirm" placeholder={tr.t("Confirmpass")} maxLength="50" minLength="8" onChange={this.handleChangePassword1} />
																<p>{ tr.t("Passleast") }</p>
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
															<button disabled={this.state.password.length < 8 || this.state.password !== this.state.password1} className="sn_btn" onClick={this.forward3}>{tr.t("Continue")}</button>  
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							{
								this.state.changeScreenNum === 4 ?
								<div>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-12 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
										</div>
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_recover pt-0 pt-lg-5">
										{/*
										<div className="sn_login__return">
											<a href="https://www.mypass.ski/">{tr.t("Returnsite")}</a>
										</div>
										*/}
										<div className="container mt-0 mt-lg-5">
											<div className="row">
												<div className="col-12 col-lg-9 mx-auto">
													<div className="sn_register__container">
														<div className="row mb-4 text-center">
															<div className="col-12">
																<div className="sn_bought__container__image mb-5 mx-auto">
																	<img src={ trueImg } alt=""/>
																</div>
																<h3 className="text-center">{ tr.t("Passchanged") }</h3>
																<p classsName="text-center">{ tr.t("Changeinfo") }</p>
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex justify-content-center justify-content-lg-end">
																<button onClick={(e) => { this.onSuccess(e) }} className="sn_btn">{tr.t("Continue")}</button>
                      				</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : null
							}
							</MobileView>
						</div>
						{
							this.state.inScreenPopupShow ?
							<div className="containerModal">
									{
											this.state.inScreenPopupShow ?
											<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
									}
							</div> : null
						}
					</div>
				</Router>
        );
    }
}

export default Recuperapass;

//validating the email
function isEmailValid(email) {
    var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


// WEBPACK FOOTER //
// ./src/screens/Recuperapass/Recuperapass.js